// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"75c34a85ec514ca58a11","761":"7172297b61da801a165e"}[chunkId] + ".2110.js";
};